// extracted by mini-css-extract-plugin
module.exports = {"button":"Favorite_button__34vQA","active":"Favorite_active__Y8_t8"};